import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=5c21af36&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemIcon } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VFlex,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VNavigationDrawer,VRow})
